export default "__VITE_ASSET__e6f801af__"